var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-row", [
        _c("h4", {}, [
          _vm._v(
            " " +
              _vm._s(
                _vm.$t(
                  "settings.delegationRate.standardDelegationRateVehicle.title"
                )
              ) +
              " "
          )
        ])
      ]),
      _c(
        "div",
        [
          _c(
            "v-col",
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.formValid,
                    callback: function($$v) {
                      _vm.formValid = $$v
                    },
                    expression: "formValid"
                  }
                },
                [
                  _c("text-field-with-set-default-checkbox", {
                    attrs: {
                      model:
                        _vm.delegationRateVehicle
                          .delegation_vehicle_under_900_rate,
                      checkboxText: _vm.$t(
                        "settings.delegationRate.customDelegationRate.inheritFromParent"
                      ),
                      label: _vm.$t(
                        "settings.delegationRate.standardDelegationRateVehicle.vehicleUnder900"
                      ),
                      type: "number"
                    },
                    on: {
                      "update:model": function($event) {
                        return _vm.$set(
                          _vm.delegationRateVehicle,
                          "delegation_vehicle_under_900_rate",
                          $event
                        )
                      }
                    }
                  }),
                  _c("text-field-with-set-default-checkbox", {
                    attrs: {
                      model:
                        _vm.delegationRateVehicle
                          .delegation_vehicle_above_900_rate,
                      checkboxText: _vm.$t(
                        "settings.delegationRate.customDelegationRate.inheritFromParent"
                      ),
                      label: _vm.$t(
                        "settings.delegationRate.standardDelegationRateVehicle.vehicleAbove900"
                      ),
                      type: "number"
                    },
                    on: {
                      "update:model": function($event) {
                        return _vm.$set(
                          _vm.delegationRateVehicle,
                          "delegation_vehicle_above_900_rate",
                          $event
                        )
                      }
                    }
                  }),
                  _c("text-field-with-set-default-checkbox", {
                    attrs: {
                      model:
                        _vm.delegationRateVehicle.delegation_vehicle_moped_rate,
                      checkboxText: _vm.$t(
                        "settings.delegationRate.customDelegationRate.inheritFromParent"
                      ),
                      label: _vm.$t(
                        "settings.delegationRate.standardDelegationRateVehicle.moped"
                      ),
                      type: "number"
                    },
                    on: {
                      "update:model": function($event) {
                        return _vm.$set(
                          _vm.delegationRateVehicle,
                          "delegation_vehicle_moped_rate",
                          $event
                        )
                      }
                    }
                  }),
                  _c("text-field-with-set-default-checkbox", {
                    attrs: {
                      model:
                        _vm.delegationRateVehicle
                          .delegation_vehicle_motorcycle_rate,
                      checkboxText: _vm.$t(
                        "settings.delegationRate.customDelegationRate.inheritFromParent"
                      ),
                      label: _vm.$t(
                        "settings.delegationRate.standardDelegationRateVehicle.motorcycle"
                      ),
                      type: "number"
                    },
                    on: {
                      "update:model": function($event) {
                        return _vm.$set(
                          _vm.delegationRateVehicle,
                          "delegation_vehicle_motorcycle_rate",
                          $event
                        )
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-btn",
        {
          attrs: {
            disabled: !_vm.formValid || _vm.$store.getters["Ajax/loading"],
            block: "",
            color: "accent"
          },
          on: {
            click: function($event) {
              return _vm.save()
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("global.save")))]
      ),
      _c("h4", [
        _vm._v(
          _vm._s(_vm.$t("settings.delegationRate.standardDelegationRate.title"))
        )
      ]),
      _c(
        "v-row",
        { staticClass: "mb-3" },
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("global.search"),
                  "append-icon": "search",
                  "hide-details": "",
                  "single-line": ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "v-col",
            { staticClass: "mx-3" },
            [
              _c("v-checkbox", {
                attrs: {
                  label: _vm.$t(
                    "settings.delegationRate.customDelegationRate.showInherited"
                  )
                },
                model: {
                  value: _vm.showInherited,
                  callback: function($$v) {
                    _vm.showInherited = $$v
                  },
                  expression: "showInherited"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "my-3" },
            [
              _c(
                "DelegationRateFormDialog",
                { attrs: { "group-id": _vm.id }, on: { saved: _vm.loadList } },
                [
                  _c("v-btn", { attrs: { block: "", color: "accent" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "settings.delegationRate.standardDelegationRate.addNewRate"
                        )
                      )
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.filteredDelegationRates,
          search: _vm.search,
          "custom-filter": _vm.filterOverAllProperty
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getCountryTranslatedName(
                            props.item.country_symbol
                          )
                        ) +
                        " "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.region))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      _vm._s(props.item.amount) +
                        " " +
                        _vm._s(props.item.currency)
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      _vm._s(props.item.hotel_limit) +
                        " " +
                        _vm._s(props.item.currency)
                    )
                  ]),
                  _c("td", { staticClass: "text-center text-no-wrap" }, [
                    props.item.group_id === _vm.id
                      ? _c(
                          "span",
                          [
                            _c("DelegationRateFormDialog", {
                              attrs: { id: props.item.id, "group-id": _vm.id },
                              on: { saved: _vm.loadList }
                            }),
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  icon: "",
                                                  disabled:
                                                    _vm.$store.getters[
                                                      "Ajax/loading"
                                                    ]
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.remove(
                                                      props.item
                                                    )
                                                  }
                                                }
                                              },
                                              on
                                            ),
                                            [_c("v-icon", [_vm._v("delete")])],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("global.delete")) + " "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "settings.delegationRate.customDelegationRate.inheritFrom"
                              )
                            ) +
                              ": " +
                              _vm._s(
                                props.item.group_name != null
                                  ? props.item.group_name
                                  : _vm.$t(
                                      "settings.delegationRate.customDelegationRate.systemSettings"
                                    )
                              ) +
                              " "
                          )
                        ])
                  ])
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }